import { FormControl, MenuItem, Select } from "@mui/material";
import React, { useEffect } from "react";
import FixedDecimalTextField from "../components/FixedDecimalTextField";

const ColumnDisc = ({
  item,
  params,
  handleRowUpdate,
  formAction,
  documentSelectTableData,
  rowError,
}) => {
  return (
    <section style={{ display: "flex", flexDirection: "column", gap: 0 }}>
      <div style={{ display: "flex", width: "100%" }}>
        <div style={{ flex: "1", minWidth: "30%" }}>
          <DiscountPriceComponent
            item={item}
            params={params}
            handleRowUpdate={handleRowUpdate}
            formAction={formAction}
            documentSelectTableData={documentSelectTableData}
            rowError={rowError}
          />
        </div>

        <div style={{ flex: "0 1 auto", minWidth: "35%" }}>
          <DiscountSelectComponent
            item={item}
            params={params}
            handleRowUpdate={handleRowUpdate}
            formAction={formAction}
            documentSelectTableData={documentSelectTableData}
          />
        </div>
      </div>
    </section>
  );
};

function DiscountPriceComponent({
  item,
  params,
  handleRowUpdate,
  formAction,
  documentSelectTableData,
  rowError,
}) {
  const fieldName = item?.sColumnID;
  const component = item?.inputType?.component;

  const fieldId =
    params?.row?._fieldIds?.[fieldName] ||
    item?.inputType?.component?.sName;

  useEffect(() => {
    if (formAction === "EDIT" || documentSelectTableData?.length !== 0) {
      return;
    }

    if (params?.row?.[fieldName] !== undefined && params?.row?.[fieldName] !== "") {
      return;
    }

    const defaultValue = component?.sDefaultValue ?? "0";

    handleRowUpdate({
      fieldName,
      value: defaultValue,
      rowId: params?.row?.id,
    });
  }, []);

  return (
    <FixedDecimalTextField
      component={component}
      placeholder={component?.sPlaceHolder}
      id={item?.inputId || `${fieldId}-${params?.row?.id}`}
      value={params?.row?.[fieldName] ?? component?.sDefaultValue ?? "0"}
      onValueChange={value => {
        handleRowUpdate({ fieldName, value, rowId: params?.row?.id });
      }}
      error={!!rowError}
      helperText={rowError || ""}
    />
  );
}

function DiscountSelectComponent({
  item,
  params,
  handleRowUpdate,
  formAction,
  documentSelectTableData,
}) {
  useEffect(() => {
    if (
      !params?.row?.col_disc_select &&
      formAction !== "EDIT" &&
      documentSelectTableData?.length === 0
    ) {
      handleRowUpdate({
        rowId: params?.row?.id,
        fieldName: "col_disc_select",
        value: "%",
      });
    }
  }, [params?.row?.col_disc_select]);

  const fieldId =
    params?.row?._fieldIds?.[item?.sColumnID] ||
    item?.inputType?.component?.sName;

  return (
    <FormControl
      {...item?.inputType?.component?.sProps}
      {...item?.inputType?.component?.options?.others1}
    >
      <Select
        id={item?.selectId || `${fieldId}-type-${params?.row?.id}`}
        value={params?.row?.col_disc_select ?? "%"}
        onChange={(e) =>
          handleRowUpdate({
            rowId: params?.row?.id,
            fieldName: "col_disc_select",
            value: e?.target?.value,
          })
        }
        {...item?.inputType?.component?.sProps}
        {...item?.inputType?.component?.options?.others1}
      >
        <MenuItem value="%">%</MenuItem>
        <MenuItem value="Fix">Fix</MenuItem>
      </Select>
    </FormControl>
  );
}

export default ColumnDisc;
